//views
import constructorTemplate from "servicestack/auto-query/auto-query-text-filter.constructor.htm";
import mainTemplate from "servicestack/auto-query/auto-query-text-filter.htm";
import wrapperTemplate from "servicestack/auto-query/auto-query-text-filter.wrapper.htm";
import basicController from "servicestack/basic.controller.properties";

//controller
import ServiceBusController from "servicestack/service-bus.controller";

export const views = {
  main: mainTemplate,
  "constructor.autocomplete": constructorTemplate,
};

export class AutoQueryTextFilterController extends ServiceBusController {
  $onInit() {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.view = views[$ctrl.filter.view] || views.main;
    // console.log("AutoQueryTextFilter", $ctrl.view, {
    //   views,
    //   $ctrl,
    // });
  }
  search(value) {
    const $ctrl = this;
    $ctrl.query.load(true);
    $ctrl.query.scrollTop && $pageConfig && $pageConfig.goTop();
  }
}

export default {
  bindings: {
    filter: "<",
  },
  controller: AutoQueryTextFilterController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || wrapperTemplate;
  },
};
